module.exports = __webpack_public_path__ + "static/media/Logo-Cibrius_Completa.b7eeffb2.png";